import React from 'react'
import FlexView from 'react-flexview/lib';
import { Tooltip } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import DroneImg from '../../../../assets/policyhistory/drone_.png';
import LiabilityImg from '../../../../assets/policyhistory/liability_.png';
import PurchasedImg from '../../../../assets/policyhistory/purchased_.png';
import './PolicyUpdateListItem.scss'
import dayjs from 'dayjs';
import { FirebaseService, FirebaseConfigKey } from '../../../../services/FirebaseService';
import policymanagementApi from '../../../../api/policymanagement.api'
interface PolicyUpdateListItemProps {
    title: String,
    startDate: Date,
    endDate: Date,
    type: String,
    downloadLinkText: String,
    purchaseDate: String,
    midtermId: String,
    insuranceId: String,
    has_pdf: Boolean,
}

export const PolicyUpdateListItem = ({title,changes, startDate, endDate, type, downloadLinkText, purchaseDate, midtermId, insuranceId, has_pdf, ...props} : PolicyUpdateListItemProps) => {

    const getImage = () => {
        if(type == 'liability') return <img src={LiabilityImg} className="history-item-img" />
        else if(type == 'purchased') return <img src={PurchasedImg} className="history-item-img" />
        else if(type == 'drone') return <img src={DroneImg} className="history-item-drone" />
        else if(type == 'aiextension') return <InsertDriveFileIcon className="lightgrayblue history-item-img" />
        else return <img src={PurchasedImg} className="history-item-img" />
    }

    const openDownloadLink = async () => {
        if(title == 'Midterm') {
            const url = await policymanagementApi.getMidtermUrl(insuranceId, midtermId)
            window.open(url.data, "_blank")
        } else {
            const url = await policymanagementApi.getPolicyUrl(insuranceId)
            window.open(url.data, "_blank")
        }
    }


    return ( <FlexView vAlignContent={'center'} className="history-item">
                <FlexView className="history-step-circle">{getImage()}</FlexView>
                <FlexView vAlignContent={'center'} className="space-between full-width">
                    <FlexView column className="margin-left-6">
                        <FlexView style={{alignItems: 'flex-start'}}>
                            <div className="text-small black bold">{title}</div>
                        </FlexView>
                        {!!changes && Object.keys(changes).map((key) => 
                                     <div className="text-tiny gray">{changes[key]}</div>)}
                        {
                            startDate > new Date() ?
                                <div className="text-tiny gray">Effective from {dayjs(startDate).format(FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT).toUpperCase())}</div>
                                :
                                <div className="text-tiny gray">Effective until {dayjs(endDate).format(FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT).toUpperCase())}</div>
                        }
                    </FlexView>
                    <FlexView column style={{alignItems: 'flex-end'}}>
                        {!!downloadLinkText && has_pdf &&  <FlexView onClick={openDownloadLink}>
                            <Tooltip placement="top" title={downloadLinkText}>
                                <CloudDownloadIcon className="clickable blue" />
                            </Tooltip>
                        </FlexView>}
                        <div className="text-tiny gray">{dayjs(purchaseDate).format(FirebaseService.getValue(FirebaseConfigKey.DATE_TIME_FORMAT).toUpperCase())}</div>
                    </FlexView>
                </FlexView>
        </FlexView>
    )
}